import { render, staticRenderFns } from "./searchbar.vue?vue&type=template&id=3698a936&"
import script from "./searchbar.vue?vue&type=script&lang=ts&"
export * from "./searchbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3698a936')) {
      api.createRecord('3698a936', component.options)
    } else {
      api.reload('3698a936', component.options)
    }
    module.hot.accept("./searchbar.vue?vue&type=template&id=3698a936&", function () {
      api.rerender('3698a936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/searchbar/searchbar.vue"
export default component.exports